import { ICreateProcessoRiscosUseCase } from "../../../presentation/useCases/create/create_processo_riscos_servicos_use_case";
import { IQualidadeRepository } from "../../repositories/qualidade_repository";

// CreateProcessoRiscosUseCase

export class CreateProcessoRiscosUseCase implements ICreateProcessoRiscosUseCase {
  constructor(private readonly repository: IQualidadeRepository) {}

  async createProcessoRiscos(Ano: string ): Promise<void> {
    
    await this.repository.createProcessoRiscos(Ano);
  }
}